export enum DeviceType {
    COMPUTER = 'COMPUTER',
    TABLET = 'TABLET',
    MOBILE = 'MOBILE',
    UNKNOWN = 'UNKNOWN'
}
